// extracted by mini-css-extract-plugin
export default {"root":"CollectorCard_root__ntZPp","list":"CollectorCard_list__sz3jo","row":"CollectorCard_row__3nQbI","label":"CollectorCard_label__mxZxr","value":"CollectorCard_value__x0qIl"};